import React from 'react';
import Avatar from 'material-ui/Avatar'
import {getImageSourceFromType, getFormattedDate} from 'util/util';
import PropTypes from "prop-types";

const NotificationItem = ({notification, onNotificationClick}) => {
    const {notificationType, description, deviceID, notificationTimestampActive} = notification;
    return (
        <li className="media" onClick={() => onNotificationClick(deviceID, notificationTimestampActive)}>
            <Avatar
                alt={notificationType}
                src={getImageSourceFromType(notificationType)}
                className=" mr-2"
            />
            <div className="media-body align-self-center">
                <p className="sub-heading mb-0">{description}</p>
                <span className="meta-date float-left"><small>{deviceID}</small></span>
                <span className="meta-date float-right"><small>{getFormattedDate(notificationTimestampActive, false)}</small></span>
            </div>
        </li>
    );
};

NotificationItem.propTypes = {
    notification: PropTypes.object.isRequired,
    onNotificationClick: PropTypes.func.isRequired
};

export default NotificationItem;


// WEBPACK FOOTER //
// ./components/AppNotification/NotificationItem.js